import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { InputFormField, SelectFormField } from "@components/FormField/HookFormFields";
import { selectAvailableCountryOptions } from "@redux";
import { FullWidthInputWrapper, HalfWidthInputWrapper } from "@components";

export const ClientRepAddress = ({ control }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);

  return (
    <>
      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.ClientCeoAdrress)}</p>
      </FullWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientRep.0.data.clientRepCountry"
          title={trb(i18.Labels.ClientRepCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientRep.0.data.clientRepCity"
          title={trb(i18.Labels.ClientRepCity)}
        />
      </HalfWidthInputWrapper>

      <FullWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientRep.0.data.clientRepStreet"
          title={trb(i18.Labels.ClientRepStreet)}
        />
      </FullWidthInputWrapper>

      {/* <FullWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientRep.0.data.clientRepHouse"
          title={trb(i18.Labels.ClientRepHouse)}
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientRep.0.data.clientRepFlat"
          title={trb(i18.Labels.ClientRepFlat)}
        />
      </FullWidthInputWrapper> */}

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientRep.0.data.clientRepPhoneNo"
          title={trb(i18.Labels.ClientRepPhoneNo)}
          type="tel"
          defaultValue="+"
        />
      </HalfWidthInputWrapper>
    </>
  );
};
